module.exports = __webpack_public_path__ + "img/Zodiaclaunch.f3527e79.jpg";